<div
  class="header-container container"
  *ngLet="(isReportsWithOtherMeanuFEOn$ | async) as isPBIWithFullMenuFEOn"
>
  <div
    class="header-content"
    *ngLet="(isPBIReportsFEOn$ | async) as isPBIReportsFEOn"
  >
    <mojo-mobile-menu></mojo-mobile-menu>
    <nav class="navbar">
      <a
        class="navbar-brand logo"
        [routerLink]="((isPBIReportsFEOn && isPBIWithFullMenuFEOn) || !isPBIReportsFEOn) ? ['/'] : undefined"
      >
        <img src="assets/images/mojo-header-icon.svg">
      </a>
      <ng-container *ngIf="showContainer('jobs')">
        <a
          routerLink="/jobs"
          routerLinkActive="active"
          *mojoHasPrivilege="privileges.job.view"
          class="nav-link"
          data-cy="header-navigate-to-jobs"
        >Jobs</a>
      </ng-container>
      <ng-container *ngIf="showContainer('candidates')">
        <a
          routerLink="/candidates"
          routerLinkActive="active"
          *mojoHasPrivilege="privileges.candidates.view"
          class="nav-link"
          data-cy="header-navigate-to-candidates"
        >Candidates</a>
      </ng-container>
      <ng-container *ngIf="showContainer('companies')">
        <a
          routerLink="/companies"
          routerLinkActive="active"
          *mojoHasPrivilege="privileges.companies.view"
          class="nav-link"
          data-cy="header-navigate-to-companies"
        >Companies</a>
      </ng-container>
      <ng-container *ngIf="showContainer('talent-pools')">
        <ng-container *mojoHasFeatureExtension="talentPoolsFe">
          <ng-container *mojoHasPrivilege="talentPoolsPrivilege">
            <a
              routerLink="/talent-pools"
              routerLinkActive="active"
              class="nav-link"
            >Talent pools</a>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="showContainer('reports')">
        <ng-container *mojoHasFeatureExtension="referralReport">
          <a
            routerLink="/reports"
            routerLinkActive="active"
            *mojoHasPrivilege="privileges.reports.view"
            class="nav-link"
          >Reports</a>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="hasNewReportsAccess$ | async">
        <span
          class="nav-link"
          [matMenuTriggerFor]="newReportsMenu"
          [class.active]="newReportsActive()"
          data-cy="header-navigate-to-new-reports"
        >New Reports</span>
        <mat-menu #newReportsMenu="matMenu" class="new-reports-menu">
          <a
            mat-menu-item
            *commonMojoHasFeatureAccess="conversionAndRoiReport"
            routerLink="/new-reports/conversion-and-roi"
          >Conversion & ROI</a>
          <a
            mat-menu-item
            *commonMojoHasFeatureAccess="usageReport"
            routerLink="/new-reports/usage-report"
          >Usage Report</a>
          <a
            mat-menu-item
            *commonMojoHasFeatureAccess="projectsReport"
            routerLink="/new-reports/projects-report"
          >Projects Report</a>
        </mat-menu>
      </ng-container>
      <ng-container *ngIf="showContainer('pbi-report')">
        <a
          routerLink="/pbi-report"
          routerLinkActive="active"
          class="nav-link"
          data-cy="header-navigate-to-pbi-report"
        >PBI Reports</a>
      </ng-container>
    </nav>
    <ng-container *ngIf="showContainer('search')">
      <div
        *mojoHasAnyPrivilege="[privileges.job.view,
                privileges.candidates.view, privileges.companies.view]"
        class="global-search d-lg-flex d-none"
        [class.no-hover]="showGlobalSearch"
      >
        <mat-icon
          class="global-search-icon"
          *ngIf="!showGlobalSearch"
          data-cy="header-global-search-desktop-icon"
          (click)="toggleGlobalSearchInput()"
        >search
        </mat-icon>
        <mojo-input
          *ngIf="showGlobalSearch"
          data-cy="header-global-search-desktop-input"
          (click)="showMenu(menuTrigger, globalSearch.value)"
          (suffixClicked)="closeGlobalSearch()"
          placeholderText="Search"
          prefixIcon="search"
          suffixIcon="close"
          [searchControl]="globalSearch"
        ></mojo-input>
        <button
          mat-button
          #menuTrigger="matMenuTrigger"
          [matMenuTriggerFor]="menu"
          class="menu-trigger"
        >Menu
        </button>
        <mat-menu
          #menu="matMenu"
          class="global-search-menu"
        >
          <div
            class="menu-wrapper"
            *ngIf="(globalSearchLoading$ | async) === false; else loading"
          >
            <mojo-global-search-results
              [results]="searchResults$ | async"
              [searchedPhrase]="globalSearch.value"
            >
            </mojo-global-search-results>
          </div>
          <ng-template #loading>
            <mojo-loader class="pr-4"></mojo-loader>
          </ng-template>
        </mat-menu>
      </div>
    </ng-container>
    <div class="right-content">
      <ng-container *ngIf="showContainer('right-content')">
        <button
          mat-mini-fab
          color="primary"
          class="search-button m-center"
        >
          <mat-icon
            *mojoHasAnyPrivilege="[privileges.job.view,
                    privileges.candidates.view, privileges.companies.view]"
            class="global-search-icon d-lg-none d-flex"
            [routerLink]="['',{outlets: {modal:'global-search'}}]"
          >
            search
          </mat-icon>
        </button>
        <mojo-add-button></mojo-add-button>
        <div class="notification-button">
          <mojo-notifications-bell data-cy="bell-notification-header">
          </mojo-notifications-bell>
        </div>
      </ng-container>
      <mojo-user-management
        [isEnabledForPBIUser]="showContainer('user-profile')"
      ></mojo-user-management>
    </div>
  </div>
</div>
